import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelectChange } from '@angular/material/select';
import { PaidFeature, SubscriptionPlan } from '../../../projects/client';
import { DemoDeviceSerials } from '../../@store/demo-settings/demo-settings.model';
import { DemoSettingsStore } from '../../@store/demo-settings/demo-settings.store';

@Component({
  selector: 'app-demo-settings',
  templateUrl: './demo-settings.component.html',
  styleUrls: ['./demo-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoSettingsComponent {
  readonly PaidFeature = PaidFeature;
  readonly SubscriptionPlan = SubscriptionPlan;
  readonly DemoDeviceSerials = DemoDeviceSerials;
  constructor(protected demoSettingsStore: DemoSettingsStore) {}

  get DeviceSerials(): PaidFeature[] {
    return Object.keys(DemoDeviceSerials) as PaidFeature[];
  }
  get PaidFeatures(): PaidFeature[] {
    return Object.keys(PaidFeature) as PaidFeature[];
  }
  get SubscriptionPlans(): PaidFeature[] {
    return Object.keys(SubscriptionPlan) as PaidFeature[];
  }

  featureToggleChecked(
    value: MatSlideToggleChange,
    deviceSerial: string,
    feature: PaidFeature
  ): void {
    if (value.checked) {
      this.demoSettingsStore.triggerAddFeatures(DemoDeviceSerials[deviceSerial], [feature]);
    } else {
      this.demoSettingsStore.triggerRemoveFeatures(DemoDeviceSerials[deviceSerial], [feature]);
    }
  }

  deviceToggleChecked(value: MatSlideToggleChange, deviceSerial: string): void {
    const features: PaidFeature[] = Object.keys(PaidFeature) as PaidFeature[];
    if (value.checked) {
      this.demoSettingsStore.triggerAddFeatures(DemoDeviceSerials[deviceSerial], features);
    } else {
      this.demoSettingsStore.triggerRemoveFeatures(DemoDeviceSerials[deviceSerial], features);
    }
  }

  onPlanChanged(value: MatSelectChange, deviceSerial: string): void {
    this.demoSettingsStore.triggerUpdatePlan(DemoDeviceSerials[deviceSerial], value.value);
  }

  restoreDefault(): void {
    this.demoSettingsStore.triggerRemoveDemoConfig();
  }
}
